<app-userapi-shared-non-oauth [userApi]="userApi">

  <p [innerHTML]="userApi.api.configDescription"></p>

  <FloatingLabelInput
      id="username"
      class="form-label"
      [label]="userApi.api.placeholder1 | translate"
      [appColor]="appColor()"
      [(myValue)]="userApi.username"
      (myValueChange)="userApi.configured = !!userApi.username && !!userApi.password">
  </FloatingLabelInput>

  <FloatingLabelInput
      id="password"
      [type]="'password'"
      class="form-label"
      [label]="userApi.api.placeholder2 | translate"
      [appColor]="appColor()"
      [(myValue)]="userApi.password"
      (myValueChange)="userApi.configured = !!userApi.username && !!userApi.password">
  </FloatingLabelInput>

  @if (userApi.api.configType === 'USERNAME_PASSWORD_WITH_CUSTOM_PARAM') {
    <FloatingLabelInput
        id="customConfig1"
        class="form-label"
        [label]="userApi.api.placeholder3 | translate"
        [appColor]="appColor()"
        [(myValue)]="userApi.customConfig1"
        (myValueChange)="userApi.configured = !!userApi.username && !!userApi.password && !!userApi.customConfig1">
    </FloatingLabelInput>
  }

</app-userapi-shared-non-oauth>